import React from 'react';
import { FlexMiddle } from '../../Flex';

const ProjectCostCenterChip = ({ externalOptions = {}, value }) => {
  const formattedValueData = value ? (Array.isArray(value) ? value : [value]) : [];

  return (
    <FlexMiddle>
      {(externalOptions.projectSchedulingBranchCostCenters || [])
        .filter(({ id }) => formattedValueData.includes(id))
        .map(({ value: optionValue }) => optionValue)
        .join(', ')}
    </FlexMiddle>
  );
};

export default ProjectCostCenterChip;
